import { render } from "./UiForm.vue?vue&type=template&id=808376ba"
import script from "./UiForm.vue?vue&type=script&lang=js"
export * from "./UiForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__